<template id="bulkModal">
<div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
          <div class="icon">
            <i :class="'fa fa-fw fa-bell'"></i>
          </div>
          <!--img class="img-responsive" src="@/images/popthumb1.png" alt=""-->
        <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
        <h4 class="modal-title" id="myModalLabel">{{res.bulkdata}}</h4>
      </div>
      <div class="modal-body">
          <textarea v-on:dragover="bulking=true" v-on:dragleave="bulking=false" v-on:drop="bulking=false;dropFileEvent($event)" :class="'form-control '+(bulking?'active':'')" rows="3" v-model="bulk"></textarea>
          <p v-html="res.bulkdesp"></p>
                <div class="centerbutton">
            <input class="redButon" :value="res.enterbulk" type="submit" v-on:click="bulkAdd()">
          </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>

import utils from './Utils.vue'
import modalBox from './ModalBox.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

export default {
  extends: modalBox,
  name: 'bulkModal',
  data () {
    return {
      bulk:null,
      bulking:false,
      alertlist:{"nostock":[], "ltstock":[]},
    }
  },
  mounted:function() {
    var self = this;
    self.$root.$on('ok_bulkadd', data => {
      this.doBulkAdd();
    });
    self.$root.$on('dropbulkfile', data => {
      self.bulk = '';
      self.show();
      self.dropFile(data.files);
    });
  },
  methods: {
    processBulk:function(product, qtys, key) {
      var self = this;
      var qty = qtys[product.pdetails[key]];
      var tmpPs = utils.getCartStorage();
      if (tmpPs != null) {
        for (var i=0;i<tmpPs.length;i++) {
          var id = tmpPs[i].product_id;
          if (id == product.pdetails.product_id) {
            //qty = qty + parseInt(tmpPs[i].oqty);
            product.idx = i;
            break;
          }
        }
      }
      product.to_oqty = qty;
      product.stock = parseInt(product.stock) + utils.getAQty(product.pdetails.product_id);
      if ((product.wbuym != null && product.wbuym != '0')) {
        product.wbuym = parseInt(product.wbuym);
        product.wfreen = parseInt(product.wfreen);
      } else {
        product.wbuym = 0;
      }
      if (product.stock <= 0) {
        self.alertlist.nostock.push(product);
      } else if (product.stock < qty) {
        product.ad_oqty = product.stock;
        if ((product.wbuym != null && product.wbuym != 0 && (((product.wbuym + product.wfreen) > product.stock) || (product.ad_oqty % (product.wbuym + product.wfreen)) != 0))) {
          product.ad_oqty = Math.floor(product.stock / (parseInt(product.wbuym) + parseInt(product.wfreen))) * (parseInt(product.wbuym) + parseInt(product.wfreen));
        }
        if (product.ad_oqty == 0) {
          product.ad_oqty = product.stock;
        }
        self.alertlist.ltstock.push(product);
      } else if ((product.wbuym != null && product.wbuym != 0 && (((product.wbuym + product.wfreen) > product.stock) || (qty % (product.wbuym + product.wfreen)) != 0))) {
        self.alertlist.ltstock.push(product);
        product.ad_oqty = Math.ceil(product.to_oqty / (parseInt(product.wbuym) + parseInt(product.wfreen))) * (parseInt(product.wbuym) + parseInt(product.wfreen));
      } else {
        if (product.wbuym != 0) {
          //qty = Math.ceil(qty / (parseInt(product.wbuym) + parseInt(product.wfreen))) * (parseInt(product.wbuym) + parseInt(product.wfreen));
          qty = parseInt(qty / (product.wbuym + product.wfreen)) * product.wbuym;
        }
        if (product.idx >= 0) {
          this.$root.$emit('qty', {idx:product.idx, oqty:qty, refresh:false});
        } else {
          this.$root.$emit('buy', {details:product, oqty:qty, refresh:false});
        }
      }
      this.cartP = null;
      this.$forceUpdate();
    },
    dropFileEvent:function(evt) {
      evt.preventDefault();
      this.dropFile(evt.dataTransfer.files);
    },
    dropFile:function(files) {
      var self = this;
      for (var i=0;i<files.length;i++) {
        var file = files[i];
        if (file.type.indexOf("text") == 0) {
          var reader = new FileReader();
          reader.onload = function(e) {
            if (e.target.result && e.target.result.length > 0) {
              if (self.bulk == null) self.bulk = '';
              else if (self.bulk.length > 0) self.bulk = self.bulk.trim() + '\n';
              else self.bulk = '';
              self.bulk = self.bulk + e.target.result;
            }
          }
          reader.readAsText(file);
        }
      }
    },
    bulkAdd:function() {
      this.$root.$emit('chk_buy', {'action':'ok_bulkadd'});
    },
    doBulkAdd:function() {
      this.close();
      this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.common_res.message.waiting});
      var codeidx = 2;
      var pididx = 3;
      var qtyidx = 1;
      var self = this;
      this.$root.$emit('bulk', {'processing':true});
      //var bulkline = /(?<qty>[0-9]*)[\s]*x[\s\S]* (?:[\s]*\[(?<code>[0-9,]*)\])?(?:\{(?<id>[0-9]*)\})?/;
      var bulkline = /([0-9]*)[\s]*x[\s\S]* (?:[\s]*\[([0-9,]*)\])?(?:\{([0-9]*)\})?/;
try {
      if (this.bulk != null) {
        this.bulk = this.bulk.replace(/\] \{/g, "]{");
        var lines = this.bulk.split('\n');
        var pids = "";
        var qtys = {};
        var eqtys = {};
        var eans = [];
        var ids = [];
        var tmpCur = utils.getCartStorage();
        for(var i = 0;i < lines.length;i++) {
          if (lines[i].trim() == '') continue;
          var info = bulkline.exec(lines[i]);
          //var info = lines[i].split(',');
          if (info == null) {
            throw {'name':'invalidBulk', 'lineno':i, 'str':lines[i]}
            //continue;
          }
          if (info[2] == null && info[3] == null) {
            throw {'name':'invalidBulk', 'lineno':i, 'str':lines[i]}
          }
          if (info.length == 2) {
            info.splice(0, 0, info[codeidx]);
          }
          if (info[qtyidx] == '') {
            continue;
          }
          if (isNaN(info[qtyidx])) {
            throw {'name':'invalidBulk', 'lineno':i, 'str':lines[i]}
            //continue;
          }
          if (parseInt(info[qtyidx]) <= 0) {
            continue;
          }
          var eint = parseInt(info[codeidx]);
          var cq = null;
          if (isNaN(eint) || eint < 1000000) {
            eint = parseInt(info[pididx]);
            cq = eqtys[info[pididx]];
            if (cq == null || cq == undefined) {
              eqtys[info[pididx]] = 0;
              cq = -1;
            }
            if (!isNaN(eint) && eint > 10000000) {
              if (cq == -1) eans.push(info[pididx]);
              eqtys[info[pididx]] = eqtys[info[pididx]] + parseInt(info[qtyidx]);
            } else {
              if (cq == -1) eans.push('');
              eqtys[info[pididx]] = eqtys[info[pididx]] + parseInt(info[qtyidx]);
            }
            qtys[info[pididx]] = eqtys[info[pididx]]
          } else {
            cq = eqtys[info[codeidx]];
            if (cq == null || cq == undefined) {
              eqtys[info[codeidx]] = 0;
              cq = -1;
            }
            if (cq == -1) eans.push(info[codeidx]);
            eqtys[info[codeidx]] = eqtys[info[codeidx]] + parseInt(info[qtyidx]);
            qtys[info[pididx]] = eqtys[info[codeidx]]
          }
          if (cq == -1) pids = pids + '&product_id='+info[pididx];
          if (cq == -1) ids.push(info[pididx]);
          //qtys[info[pididx]] = parseInt(info[qtyidx]);
          //code here using lines[i] which will give you each line
        }
        var self = this;
        Vue.http.get(utils.getServerPath()+'/product/search.is?'+pids).then(response => {
          var productlist = response.body.productlist;
          self.alertlist = {"nostock":[], "ltstock":[]};
          if (productlist != null && productlist.length > 0) {
            for (var i=0;i<productlist.length;i++) {
              self.processBulk(productlist[i], qtys, 'product_id');
              var idx = eans.indexOf(productlist[i].pdetails.product_code);
              if (idx >= 0) {
                eans.splice(idx, 1);
                ids.splice(idx, 1);
              } else {
                idx = ids.indexOf(productlist[i].pdetails.product_id);
                if (idx >= 0) {
                  eans.splice(idx, 1);
                  ids.splice(idx, 1);
                }
              }
            }
          }
          if (eans.length > 0) {
            var plist = [];
            for (var i=0;i<eans.length;i++) {
              if (eans[i] == '') continue;
              plist.push(
                new Promise((resolve, reject) => {
                  Vue.http.get(utils.getServerPath()+'/product/search.is?product_name='+eans[i]).then(response => {
                    if (response.body.productlist != null) {
                      resolve(response.body.productlist[0]);
                    } else {
                      resolve(null);
                    }
                  }).catch (err => {
                    resolve(null);
                  });
                })
              );
            }
            Promise.all(plist).then(list => {
              if (list != null) {
                for (var i=0;i<list.length;i++) {
                  if (list[i] != null) {
                    self.processBulk(list[i], eqtys, 'product_code');
                  }
                }
              }
              //$('#myModal').modal('hide');
              this.$root.$emit('modal.bulkbox', {'mode':'hide'});
              if (self.alertlist.nostock.length > 0 || self.alertlist.ltstock.length > 0) {
                setTimeout(function() {
                  self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
                  self.$root.$emit('modal.bulklistbox', {'mode':'show', 'params':self.alertlist});
                  self.$root.$emit('bulk', {'processing':false});
                }, 2000);
                //$('#myModal01').modal('show');
              } else {
                self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
                self.$root.$emit('bulk', {'processing':false});
              }
            }).catch(err => {
            });
          } else {
            //$('#myModal').modal('hide');
            this.$root.$emit('modal.bulkbox', {'mode':'hide'});
            if (self.alertlist.nostock.length > 0 || self.alertlist.ltstock.length > 0) {
              setTimeout(function() {
                self.$root.$emit('bulk', {'processing':false});
                self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
                self.$root.$emit('modal.bulklistbox', {'mode':'show', 'params':self.alertlist});
              }, 2000);
              //$('#myModal01').modal('show');
            } else {
              self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
              self.$root.$emit('bulk', {'processing':false});
            }
          }
        });
      }
} catch (e) {
  if (e.name == 'invalidBulk') {
    this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':'invalid line no '+(e.lineno+1)+', ('+e.str+')', 'button':'Close', 'icon':'fa-exclamation'});
  }
}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BulkModal.vue